import { Context, Schema } from "effect"
import { HttpApiEndpoint, HttpApiGroup, HttpApiMiddleware, HttpApiSchema, HttpApiSecurity } from "effect/http-api"
import { InvalidCredentials, TooManyLoginAttempts, Unauthorized } from "./Errors.ts"

export const SESSION_COOKIE = "trader_session"

export const UserId = Schema.Number.pipe(Schema.brand("UserId"))
export type UserId = typeof UserId.Type

export const User = Schema.Struct({
  id: UserId,
  username: Schema.String
})
export type User = typeof User.Type

/** The authenticated user, provided to handlers by the Authentication middleware. */
export class CurrentUser extends Context.Service<CurrentUser, User>()("trader/auth/CurrentUser") {}

export const sessionCookie = HttpApiSecurity.apiKey({ key: SESSION_COOKIE, in: "cookie" })

// Browsers send the cookie on their own, so clients don't implement this middleware.
export class Authentication extends HttpApiMiddleware.Service<Authentication, {
  provides: CurrentUser
  requires: never
}>()("trader/auth/Authentication", {
  security: { session: sessionCookie },
  error: Unauthorized
}) {}

export const LoginRequest = Schema.Struct({
  username: Schema.String.pipe(Schema.check(Schema.isNonEmpty())),
  password: Schema.String.pipe(Schema.check(Schema.isNonEmpty()))
})

export class AuthApi extends HttpApiGroup.make("auth")
  .add(
    HttpApiEndpoint.post("login", "/login", {
      payload: LoginRequest,
      success: User,
      error: [InvalidCredentials, TooManyLoginAttempts]
    }),
    HttpApiEndpoint.post("logout", "/logout", { success: HttpApiSchema.NoContent }).middleware(Authentication),
    HttpApiEndpoint.get("me", "/me", { success: User }).middleware(Authentication)
  )
  .prefix("/auth")
{}
